import { render, staticRenderFns } from "./brokerCodes.vue?vue&type=template&id=5984f633&scoped=true&"
import script from "./brokerCodes.vue?vue&type=script&lang=js&"
export * from "./brokerCodes.vue?vue&type=script&lang=js&"
import style0 from "./brokerCodes.vue?vue&type=style&index=0&id=5984f633&scoped=true&lang=css&"
import style1 from "./brokerCodes.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5984f633",
  null
  
)

export default component.exports